import { schema, types } from 'papr'

export const blockedUserSchema = schema({
	from: types.objectId({ required: true }),
	to: types.objectId({ required: true }),
})

export type BlockedUserDocument = (typeof blockedUserSchema)[0]
export type BlockedUserOptions = (typeof blockedUserSchema)[1]
